import * as React from 'react'
import { t, jt, c } from 'ttag'
import YumTextField from '../../components/YumTextField/YumTextField'
import YumButton from '../../components/YumButton/YumButton'
import { Card } from '../../components/Card/Card'
import NotificationsWrapper from '../../components/Notification/NotificationsWrapper'
import { SignUp$Request, UserProfileDto } from '../../services/api.types'
import './SignUp.scss'
import { currentLang } from '../../i18nInit'
import {
  isTextFieldErrorVisible,
  isPasswordFieldErrorVisible,
  isEmailFieldErrorVisible,
  isConsentFieldErrorVisible,
} from '../../common/helpers/formHelpers'
import InputAdornment from '@material-ui/core/InputAdornment'
import IconButton from '@material-ui/core/IconButton'
import { ReactComponent as StarIcon } from '../../assets/v2/icons/star.svg'
import { ReactComponent as StarFilledIcon } from '../../assets/v2/icons/star-filled.svg'
import { ReactComponent as StarErrorIcon } from '../../assets/v2/icons/star-error.svg'
import { ReactComponent as EmailIcon } from '../../assets/v2/icons/email.svg'
import { ReactComponent as EmailFilledIcon } from '../../assets/v2/icons/email-filled.svg'
import { ReactComponent as EmailErrorIcon } from '../../assets/v2/icons/email-error.svg'
import { ReactComponent as LockIcon } from '../../assets/v2/icons/lock.svg'
import { ReactComponent as LockFilledIcon } from '../../assets/v2/icons/lock-filled.svg'
import { ReactComponent as LockErrorIcon } from '../../assets/v2/icons/lock-error.svg'
import { ReactComponent as AcceptedIcon } from '../../assets/v2/icons/checked-circle-blue.svg'
import { ReactComponent as ErrorIcon } from '../../assets/v2/icons/error.svg'
import { ReactComponent as Visibility } from '../../assets/v2/icons/visibility.svg'
import { ReactComponent as VisibilityOff } from '../../assets/v2/icons/visibility-off.svg'
import { red } from '../../styles/material-ui-theme-v2'
import Typography from '@material-ui/core/Typography'
import YumBack from '../../components/YumBack/YumBack'
import { Checkbox, FormControlLabel, FormGroup, Tooltip } from '@material-ui/core'
import YumGoogleSignInWrapper from '../../components/YumGoogleSignIn/YumGoogleSignInWrapper'
import Loader from '../../components/Loader/Loader'
import YumAppleSignInWrapper from '../../components/YumAppleSignIn/YumAppleSignInWrapper'
import { openPricing, openPrivacyPolicy, openTermsOfService } from '../../common/helpers/routeHelpers'
import { WelcomeSidebar } from '../Welcome/Welcome'

export interface IStateProps {
  authenticated: boolean
  resetPasswordInProgress: boolean
  userDto: UserProfileDto
}

export interface IDispatchProps {
  doSignUp(payload: SignUp$Request): void
  reLocate(): void
}

type ISignUpProps = IStateProps & IDispatchProps

export interface ISignUpState {
  companyCode: string
  email: string
  password: string
  isFormValid: boolean
  isFormSubmitted: boolean
  showPassword: boolean
  errors: object
  focus: object
  [key: string]: any
}

export class SignUp extends React.Component<ISignUpProps, ISignUpState> {
  state = {
    companyCode: '',
    email: '',
    password: '',
    consent: false,
    lang: currentLang,
    isFormValid: true,
    isFormSubmitted: false,
    showPassword: false,
    errors: {
      companyCode: false,
      email: false,
      password: false,
      consent: false,
    },
    focus: {
      companyCode: false,
      email: false,
      password: false,
    },
  }

  componentDidMount() {
    //document.body.classList.add('show-illustration')
    this.props.reLocate()
  }

  /*componentWillUnmount(): void {
    document.body.classList.remove('show-illustration')
  }*/

  componentDidUpdate() {
    if (this.props.authenticated) {
      this.props.reLocate()
    }
  }

  handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value, name } = event.target
    this.setState({ [name]: value }, () => {
      this.validateField(name, value)
      this.setState({ isFormValid: this.isFormValid() })
    })
  }

  handleKeyPress = async (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.keyCode === 13) {
      // @ts-ignore
      event.target.blur()
      await this.onSubmit()
    }
  }

  validateField = async (name: string, value: string) => {
    let error
    switch (name) {
      case 'companyCode':
        error = isTextFieldErrorVisible(value)
        break
      case 'email':
        error = isEmailFieldErrorVisible(value)
        break
      case 'password':
        error = isPasswordFieldErrorVisible(value)
        break
      case 'consent':
        error = isConsentFieldErrorVisible(value)
        break
    }
    await this.setState({
      errors: { ...this.state.errors, [name]: error },
    })
    await this.setState({
      isFormValid: this.isFormValid(),
    })
  }

  handleClickShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword })
  }

  handleMouseDownPassword = (event: any) => {
    event.preventDefault()
  }

  handleFocus = (name: string) => {
    this.setState({ focus: { ...this.state.focus, [name]: true } })
  }

  handleBlur = (name: string) => {
    this.setState({ focus: { ...this.state.focus, [name]: false } })
  }

  handleConsentChange = () => {
    const value = !this.state.consent
    this.setState({ consent: value }, () => {
      // @ts-ignore
      this.validateField('consent', value)
      this.setState({ isFormValid: this.isFormValid() })
    })
  }

  isFormValid = () => !Object.values(this.state.errors).some(Boolean)

  onSubmit = async (e?: React.FormEvent<HTMLFormElement>) => {
    if (e) {
      e.preventDefault()
    }
    await this.setState({ isFormSubmitted: true })

    // Validate all fields
    await this.validateField('companyCode', this.state.companyCode)
    await this.validateField('email', this.state.email)
    await this.validateField('password', this.state.password)
    // @ts-ignore
    await this.validateField('consent', this.state.consent)
    /*Object.keys(this.state.errors).forEach((name: keyof ISignUpState) => {
      //const value: any = this.state[name]
      const value: any = this.state[name as keyof ISignUpState]
      this.validateField(name, value)
    })*/

    if (this.state.isFormValid) {
      await this.props.doSignUp(this.state)
    }
  }

  handleTermsOfService = (e: any) => {
    e.preventDefault()
    openTermsOfService()
  }

  handlePrivacyPolicy = (e: any) => {
    e.preventDefault()
    openPrivacyPolicy()
  }

  render() {
    const { companyCode, email, password, showPassword } = this.state

    const companyCodeNotEmpty = !!companyCode
    const emailNotEmpty = !!email
    const passwordNotEmpty = !!password

    const tos = (
      <a key={'tos'} className={'link'} onClick={this.handleTermsOfService}>{c('In sentence').t`Terms of Service`}</a>
    )
    const pp = (
      <a key={'pp'} className={'link'} onClick={this.handlePrivacyPolicy}>{c('In sentence').t`Privacy Policy`}</a>
    )

    const title = t`Join YuMuuv`
    return (
      <Card className="sign-up pt-12">
        <div className="sign-up__inner">
          <YumBack to="/" />
          <NotificationsWrapper />
          <Loader />

          <form className="sign-up__form" onSubmit={this.onSubmit} noValidate>
            <Typography className={'h1-desktop'} variant="h1">
              {title}
            </Typography>
            <div className="info">
              <span>{t`You can only join YuMuuv as part of an organization that has purchased a plan.`}</span>
              {` `}
              <a href={undefined} onClick={openPricing}>{t`Learn more`}</a>
            </div>
            <YumTextField
              placeholder={t`Sign up code`}
              type="text"
              name="companyCode"
              className="uppercase-value"
              error={this.state.errors.companyCode}
              onChange={this.handleInputChange}
              onKeyDown={this.handleKeyPress}
              onFocus={() => this.handleFocus('companyCode')}
              onBlur={() => this.handleBlur('companyCode')}
              autoCapitalize="characters"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    {this.state.errors.companyCode && !this.state.focus.companyCode ? (
                      <StarErrorIcon />
                    ) : companyCodeNotEmpty || this.state.focus.companyCode ? (
                      <StarFilledIcon />
                    ) : (
                      <StarIcon />
                    )}
                  </InputAdornment>
                ),
                endAdornment: this.state.errors.companyCode ? (
                  <InputAdornment position="end">
                    <Tooltip
                      title={t`Wrong sign up code`}
                      placement="top-end"
                      open={companyCodeNotEmpty && !this.state.focus.companyCode}
                      arrow
                    >
                      <ErrorIcon />
                    </Tooltip>
                  </InputAdornment>
                ) : companyCodeNotEmpty ? (
                  <InputAdornment position="end">
                    <AcceptedIcon />
                  </InputAdornment>
                ) : (
                  ''
                ),
              }}
            />
            <YumTextField
              placeholder={t`Email`}
              type="email"
              name="email"
              autoComplete="email"
              error={this.state.errors.email}
              onChange={this.handleInputChange}
              onKeyDown={this.handleKeyPress}
              onFocus={() => this.handleFocus('email')}
              onBlur={() => this.handleBlur('email')}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    {this.state.errors.email && !this.state.focus.email ? (
                      <EmailErrorIcon />
                    ) : emailNotEmpty || this.state.focus.email ? (
                      <EmailFilledIcon />
                    ) : (
                      <EmailIcon />
                    )}
                  </InputAdornment>
                ),
                endAdornment: this.state.errors.email ? (
                  <InputAdornment position="end">
                    <Tooltip
                      title={t`Something is wrong with this email`}
                      placement="top-end"
                      open={emailNotEmpty && !this.state.focus.email}
                      arrow
                    >
                      <ErrorIcon />
                    </Tooltip>
                  </InputAdornment>
                ) : emailNotEmpty ? (
                  <InputAdornment position="end">
                    <AcceptedIcon />
                  </InputAdornment>
                ) : (
                  ''
                ),
              }}
            />
            <YumTextField
              style={{ marginBottom: '6px' }}
              placeholder={t`Password`}
              type={showPassword ? 'text' : 'password'}
              name="password"
              error={this.state.errors.password}
              onChange={this.handleInputChange}
              onKeyDown={this.handleKeyPress}
              onFocus={() => this.handleFocus('password')}
              onBlur={() => this.handleBlur('password')}
              autoComplete="new-password"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    {this.state.errors.password && !this.state.focus.password ? (
                      <LockErrorIcon />
                    ) : passwordNotEmpty || this.state.focus.password ? (
                      <LockFilledIcon />
                    ) : (
                      <LockIcon />
                    )}
                  </InputAdornment>
                ),
                endAdornment: this.state.errors.password ? (
                  <InputAdornment position="end">
                    <Tooltip
                      title={t`Password must be at least 6 characters`}
                      placement="top-end"
                      open={passwordNotEmpty && !this.state.focus.password}
                      arrow
                    >
                      <ErrorIcon />
                    </Tooltip>
                  </InputAdornment>
                ) : passwordNotEmpty ? (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={this.handleClickShowPassword}
                      onMouseDown={this.handleMouseDownPassword}
                      edge="end"
                    >
                      {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ) : (
                  ''
                ),
              }}
            />
            <FormGroup row={true} style={{ marginBottom: '16px' }}>
              <FormControlLabel
                control={
                  <Checkbox
                    color="primary"
                    required={true}
                    name="consent"
                    checked={this.state.consent}
                    onChange={this.handleConsentChange}
                  />
                }
                label={<Typography style={{ fontSize: 14 }}>{jt`I agree to YuMuuv's ${tos} and ${pp}.`}</Typography>}
                style={this.state.errors.consent ? { color: red } : {}}
              />
            </FormGroup>
            <YumButton type="submit">{t`Sign up`}</YumButton>
            <div className={'text-center'}>
              <div className={'or-line'}>
                <span className={'or-line-inner'}>{t`or`}</span>
              </div>
              <table style={{ margin: 'auto' }}>
                <tbody>
                  <tr>
                    <td>
                      <YumAppleSignInWrapper buttonText={t`Sign up with Apple`} isSignUp={true} />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <YumGoogleSignInWrapper buttonText={t`Sign up with Google`} isSignUp={true} />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </form>
        </div>
        {/*<div className="sign-up__sidebar" />*/}
        <WelcomeSidebar />
      </Card>
    )
  }
}
